import enUS from './en-US';
import deDE from './de-DE';

export default {
  'en-US': enUS,
  'de-DE': deDE,
};

export const localeOptions = [
  { value: 'en-US', label: 'English' },
  { value: 'de-DE', label: 'Deutsch' }
];
